var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15833 11.6024L12.85 14.9191M12.8417 5.76908L7.15833 9.08574M17.5 4.51074C17.5 5.89145 16.3807 7.01074 15 7.01074C13.6193 7.01074 12.5 5.89145 12.5 4.51074C12.5 3.13003 13.6193 2.01074 15 2.01074C16.3807 2.01074 17.5 3.13003 17.5 4.51074ZM7.5 10.3441C7.5 11.7248 6.38071 12.8441 5 12.8441C3.61929 12.8441 2.5 11.7248 2.5 10.3441C2.5 8.96336 3.61929 7.84408 5 7.84408C6.38071 7.84408 7.5 8.96336 7.5 10.3441ZM17.5 16.1774C17.5 17.5581 16.3807 18.6774 15 18.6774C13.6193 18.6774 12.5 17.5581 12.5 16.1774C12.5 14.7967 13.6193 13.6774 15 13.6774C16.3807 13.6774 17.5 14.7967 17.5 16.1774Z",
    stroke: "#FE385C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.406912df1494933665a28bde1ba56c73.svg";
export { ForwardRef as ReactComponent };